export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10680.39d50dfd.jpg";